
import React from 'react'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'
import Table from 'react-bootstrap/esm/Table'
import Badge from 'react-bootstrap/esm/Badge'

// data-bs-toggle="modal" data-bs-target="#modalEmpleados"

export const ListItem = ({ empleados }) => {

    const setEmpleado = useEmpleadoStore(state => state.actualizar)

    const Aceptado = ({acept}) => acept ? <Badge bg="success">Aceptado</Badge> : <Badge bg="warning" text='dark'>Pendiente</Badge>

    return (
        <div className='container-fluid text-start' style={{ overflow: 'auto' }}>
            <Table hover>
                <thead>
                    <tr>
                        <th scope="col">Nombre</th>
                        <th scope="col">Correo electrónico</th>
                        <th scope="col">Fecha de registro</th>
                        <th scope="col">Aviso de privacidad</th>
                        <th scope="col">Ver</th>
                    </tr>
                </thead>
                <tbody>
                    {empleados.map((e, i) => (
                        <tr key={e.pk_empleado}>
                            <td>{e.apellido + ' ' + e.nombre}</td>
                            <td>{e.email}</td>
                            <td>{e.fecha_registro}</td>
                            <td><Aceptado acept={e.terminos_y_condiciones}/></td>
                            <td>
                                <button className='btn btn-outline-primary' onClick={() => setEmpleado(e.email)} data-bs-toggle="modal" data-bs-target="#modalEmpleados">
                                    <i className="bi bi-info-circle"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    )
}
